import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  'rt--notifications--notifications--box-container': {
    borderRadius: '12px',
    display: 'grid',
    gap: '8px',
    background: 'transparent',
    gridTemplateRows: 'max-content 1fr max-content',
  },
  'rt--notifications--notifications-list-container': {
    padding: '16px',
    maxHeight: 'calc(100vh - 162px)',
    overflow: 'auto',
    overflowX: 'hidden',
  },
}));
